var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { File } from "./File";
export class CustomSourceFile extends File {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CustomSourceFile
     */
    __publicField(this, "$type", "V1.ComplianceUploads.Files.CustomSourceFile");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.Type = CustomSourceFileType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["Type"] = CustomSourceFileType[this.Type];
    return _data;
  }
}
export var CustomSourceFileType = /* @__PURE__ */ ((CustomSourceFileType2) => {
  CustomSourceFileType2["Sale"] = "Sale";
  CustomSourceFileType2["Purchase"] = "Purchase";
  CustomSourceFileType2["One"] = "One";
  return CustomSourceFileType2;
})(CustomSourceFileType || {});
